import { useMemo } from 'react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar } from 'recharts';
import { useGetMeteoWindDirection } from '../../hooks/useGetMeteoWindDirection';
import FlechaDominante from './FlechaDominante';

const cardinals30 = { 0:'N', 30:'NNE', 60:'ENE', 90:'E', 120:'ESE', 150:'SSE', 180:'S', 210:'SSW', 240:'WSW', 270:'W', 300:'WNW', 330:'NNW' };

const GraficaMeteoDireccionViento = ( { meteoId , start , end } ) => {

    const { observations, loading } = useGetMeteoWindDirection({
        meteoId,
        start,
        end
    });

  const sortedObservations = useMemo(() => {
    const agrupado = {};
    observations.forEach(({ windDirection }) => {
      const sector = (Math.round(windDirection / 30) * 30 + 180) % 360;
      agrupado[sector] = (agrupado[sector] || 0) + 1;
    });
    return Object.keys(cardinals30).map(dir => {
      const angulo = Number(dir);
      const count = agrupado[angulo] || 0;
      return { angulo, direccion: cardinals30[dir], frecuencia: count };
    });
  }, [observations]);

const direccionDominante = sortedObservations.reduce((max, obs) =>
  obs.frecuencia > max.frecuencia ? obs : max
);



  return (
     <div>
           <h3>✵ Dirección del viento</h3>

           {/* Gráfica */}
           {loading ? (
             <p>Cargando observaciones...</p>
           ) : sortedObservations?.length > 0 ? (
            <div style={{ width: '100%', maxWidth: 400 }}>
            <div style={{
              width: '100%',
              aspectRatio: '1 / 1',
              backgroundColor: 'white',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative'
            }}>
              <ResponsiveContainer width="100%" height="100%">
                <RadarChart outerRadius="40%" data={sortedObservations}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="direccion" />
                  <Radar
                    name="Dirección del Viento"
                    dataKey="frecuencia"
                    stroke="#8884d8"
                    fill="#8884d8"
                    fillOpacity={0.6}
                  />
                </RadarChart>
              </ResponsiveContainer>

              {/* Flecha animada apuntando en la dirección dominante */}
              <FlechaDominante rotation={direccionDominante.angulo} />
            </div>
            </div>

           ) : (
             sortedObservations?.length === 0 && <p>No hay datos disponibles para esta estación meteo</p>
           )}


         </div>
  );
};

export default GraficaMeteoDireccionViento;
